import { connect } from 'react-redux'
import moment from 'moment'
import { Dispatch } from 'redux'
import VisualMap from '../../components/VisualMap'
import { actions as apiActions } from 'api/actions'
import * as selectors from '../../selectors'

export interface StateToProps {
    controlId: number
    data?: ViewMapDataRecord[]
    displayEndDateTime?: moment.Moment | undefined
    displayStartDateTime?: moment.Moment
    map?: EchartsMapOptions
    options?: echarts.EChartOption
    overrideDisplayDate?: boolean
    titleOptions?: TitleOptions
}

export interface DispatchToProps {
    getSettings: (controlId: number) => void
}

export const mapStateToProps = (state: RootState): StateToProps => ({
    controlId: selectors.getControlId(state),
    titleOptions: selectors.getTitleOptions(state),
    data: selectors.getMapDataRecords(state),
    displayEndDateTime: moment(selectors.getVisualMapDisplayEndDateTime(state)),
    displayStartDateTime: selectors.getVisualMapDisplayStartDateTime(state),
    map: selectors.getMapStructureOptions(state),
    options: selectors.getEChartsOptions(state),
    overrideDisplayDate: imod.cms.scoreboards.overrideDisplayDate,
})

export const mapDispatchToProps = (dispatch: Dispatch): DispatchToProps => ({
    getSettings: controlId => dispatch(apiActions.getSettings(controlId)),
})

export const DataMap = connect(mapStateToProps, mapDispatchToProps)(VisualMap)
